import { actionCreator } from 'utils';
import * as TranslationTypes from '../types/translationTypes';

// L O A D   T R A N S L A T I O N S
export function loadTranslations(payload) {
    return {
        type: TranslationTypes.LOAD_TRANSLATIONS,
        payload,
    };
}

export function loadTranslationsRes(data) {
    return {
        type: actionCreator(TranslationTypes.LOAD_TRANSLATIONS, 'res'),
        data,
    };
}

export function loadTranslationsErr() {
    return {
        type: actionCreator(TranslationTypes.LOAD_TRANSLATIONS, 'err'),
    };
}
// L O A D   T R A N S L A T I O N S

// S E T   T R A N S L A T I O N   F I L T E R S   & &   P A G I N A T I O N  &&  S O R T
export function setTranslationFilters(key, value) {
    return {
        type: TranslationTypes.SET_TRANSLATION_FILTER,
        key,
        value,
    };
}

export function setTranslationFiltersRes(data) {
    return {
        type: actionCreator(TranslationTypes.SET_TRANSLATION_FILTER, 'res'),
        data,
    };
}

export function setTranslationPagination(key, value) {
    return {
        type: TranslationTypes.SET_TRANSLATION_PAGINATION,
        key,
        value,
    };
}

export function setTranslationSort(sort) {
    return {
        type: TranslationTypes.SET_TRANSLATION_SORT,
        sort,
    };
}

export function resetTranslationFilters() {
    return {
        type: TranslationTypes.RESET_TRANSLATION_FILTERS,
    };
}
// S E T   T R A N S L A T I O N   F I L T E R S   & &   P A G I N A T I O N  &&  S O R T

// L O A D   R E S E L L E R S   F O R   T R A N S L A T I O N S
export function setResellerForTranslations(id) {
    return {
        type: TranslationTypes.SET_RESELLER_FOR_TRANSLATIONS,
        id,
    };
}
// L O A D   R E S E L L E R S   F O R   T R A N S L A T I O N S

// S E T   P R O D U C T S   F O R    T R A N S L A T I O N S
export function setProductForTranslations(name) {
    return {
        type: TranslationTypes.SET_PRODUCT_FOR_TRANSLATIONS,
        name,
    };
}

export function setEmptyProductsFromTranslation() {
    return {
        type: TranslationTypes.SET_EMPTY_PRODUCTS_FROM_TRANSLATIONS,
    };
}
// S E T   P R O D U C T S   F O R    T R A N S L A T I O N S

// L O A D   E D I T A B L E   T R A N S L A T I O N S
export function loadEditableTranslation(id, isEdit) {
    return {
        type: TranslationTypes.LOAD_EDITABLE_TRANSLATION,
        id,
        isEdit,
    };
}

export function loadEditableTranslationRes(data) {
    return {
        type: actionCreator(TranslationTypes.LOAD_EDITABLE_TRANSLATION, 'res'),
        data,
    };
}

export function loadEditableTranslationErr() {
    return {
        type: actionCreator(TranslationTypes.LOAD_EDITABLE_TRANSLATION, 'err'),
    };
}

export function setEmptyEditableTranslation() {
    return {
        type: TranslationTypes.SET_EMPTY_EDITABLE_TRANSLATIONS,
    };
}

export function setSource(payload) {
    return {
        type: TranslationTypes.SET_SOURCE,
        payload,
    };
}
// L O A D   E D I T A B L E   T R A N S L A T I O N S

// A D D   N E W   T R A N S L A T I O N S
export function addNewTranslation(data) {
    return {
        type: TranslationTypes.ADD_NEW_TRANSLATION,
        data,
    };
}

export function addNewTranslationRes(loading, success) {
    return {
        type: actionCreator(TranslationTypes.ADD_NEW_TRANSLATION, 'res'),
        loading,
        success,
    };
}

export function addNewTranslationErr(error) {
    return {
        type: actionCreator(TranslationTypes.ADD_NEW_TRANSLATION, 'err'),
        error,
    };
}
// A D D   N E W   T R A N S L A T I O N S

// E D I T   T R A N S L A T I O N S
export function editTranslations(data) {
    return {
        type: TranslationTypes.EDIT_TRANSLATIONS,
        data,
    };
}

export function editTranslationsRes(loading, success) {
    return {
        type: actionCreator(TranslationTypes.EDIT_TRANSLATIONS, 'res'),
        loading,
        success,
    };
}

export function editTranslationsErr() {
    return {
        type: actionCreator(TranslationTypes.EDIT_TRANSLATIONS, 'err'),
    };
}
// E D I T   T R A N S L A T I O N S

// S E T   T R A N S L A T I O N S   F I L T E R   &   P A G I N A T I O N
export function resetTranslationPaginationList() {
    return {
        type: TranslationTypes.RESET_TRANSLATION_PRODUCT_PAGINATION_LIST,
    };
}
// S E T   T R A N S L A T I O N S   F I L T E R   &   P A G I N A T I O N

// S E T   T R A N S L A T I O N   T A G   P O P U P
export function setTranslationTagPopup(data) {
    return {
        type: TranslationTypes.SET_TRANSLATION_TAG_POPUP,
        data,
    };
}
// S E T   T R A N S L A T I O N   T A G   P O P U P

// A D D   T R A N S L A T I O N   T A G
export function addTranslationTag(data) {
    return {
        type: TranslationTypes.ADD_TRANSLATION_TAG,
        data,
    };
}

export function addTranslationTagRes() {
    return {
        type: actionCreator(TranslationTypes.ADD_TRANSLATION_TAG, 'res'),
    };
}

export function addTranslationTagErr() {
    return {
        type: actionCreator(TranslationTypes.ADD_TRANSLATION_TAG, 'err'),
    };
}
// A D D   T R A N S L A T I O N   T A G

// E D I T   T R A N S L A T I O N   T A G
export function editTranslationTag(data) {
    return {
        type: TranslationTypes.EDIT_TRANSLATION_TAG,
        data,
    };
}

export function editTranslationTagRes() {
    return {
        type: actionCreator(TranslationTypes.EDIT_TRANSLATION_TAG, 'res'),
    };
}

export function editTranslationTagErr() {
    return {
        type: actionCreator(TranslationTypes.EDIT_TRANSLATION_TAG, 'err'),
    };
}
// E D I T   T R A N S L A T I O N   T A G
